/**
 * PERSO: onglets de la fiche produit (blocks/perso-onglets-produit.liquid).
 * Clic ou flèches gauche/droite pour changer d'onglet, Origine et Fin pour aller au premier ou au dernier.
 * Sans JavaScript, le panneau ouvert au chargement reste affiché : le contenu n'est jamais perdu.
 */

class PersoOngletsProduit extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#surClic);
    this.addEventListener('keydown', this.#surClavier);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#surClic);
    this.removeEventListener('keydown', this.#surClavier);
  }

  /** @returns {HTMLElement[]} */
  get #onglets() {
    return [...this.querySelectorAll('[role="tab"]')].filter((el) => el instanceof HTMLElement);
  }

  /** @param {HTMLElement} onglet */
  #activer(onglet) {
    for (const autre of this.#onglets) {
      const choisi = autre === onglet;
      autre.setAttribute('aria-selected', choisi ? 'true' : 'false');
      autre.tabIndex = choisi ? 0 : -1;
      const panneau = document.getElementById(autre.getAttribute('aria-controls') || '');
      panneau?.toggleAttribute('hidden', !choisi);
    }
  }

  /** @param {Event} event */
  #surClic = (event) => {
    const cible = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
    if (cible instanceof HTMLElement) this.#activer(cible);
  };

  /** @param {KeyboardEvent} event */
  #surClavier = (event) => {
    const cible = event.target;
    if (!(cible instanceof HTMLElement) || !cible.matches('[role="tab"]')) return;

    const onglets = this.#onglets;
    const position = onglets.indexOf(cible);
    let suivant = -1;

    if (event.key === 'ArrowRight') suivant = (position + 1) % onglets.length;
    if (event.key === 'ArrowLeft') suivant = (position - 1 + onglets.length) % onglets.length;
    if (event.key === 'Home') suivant = 0;
    if (event.key === 'End') suivant = onglets.length - 1;
    if (suivant < 0) return;

    const onglet = onglets[suivant];
    if (!onglet) return;
    event.preventDefault();
    this.#activer(onglet);
    onglet.focus();
  };
}

if (!customElements.get('perso-onglets-produit')) {
  customElements.define('perso-onglets-produit', PersoOngletsProduit);
}
